import { Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleChangeProfilePicture(
  resource: Identifiable<Resource>,
  {
    resource: r,
    profilePicture,
  }: Boundaries["changeProfilePicture"]["success"],
): Identifiable<Resource> {
  return r.uuid === resource.uuid
    ? { ...resource, avatarUrl: profilePicture.uuid }
    : resource;
}

export { handleChangeProfilePicture };
